import { render, staticRenderFns } from "./SortingBox.vue?vue&type=template&id=62c3869e&scoped=true"
import script from "./SortingBox.vue?vue&type=script&lang=js"
export * from "./SortingBox.vue?vue&type=script&lang=js"
import style0 from "./SortingBox.vue?vue&type=style&index=0&id=62c3869e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3869e",
  null
  
)

export default component.exports